import axios, { AxiosError } from 'axios';
import { getErrorMessage, oneData } from './api/normalizer';
import { BASE_URL } from './api/base';

export default async () => {
  try {
    return oneData(await axios.get(`${BASE_URL}/health`));
  } catch (err) {
    throw getErrorMessage(err as AxiosError);
  }
};
